import clsx from 'clsx';

import {ArrowLink} from '@/modules/finkn/components/arrow-link';
import type {FinknIcons} from '@/shared/renderIcon';
import {HoverIcon} from '@/shared/renderIcon';

export type LinkCardProps = {
	href: string;
	title: string;
	description?: string;
	icon?: FinknIcons;
};

const LinkCard = ({description, href, title, icon}: LinkCardProps) => {
	return (
		<div
			className={clsx(
				'bg-white',
				'p-6',
				'rounded-[3px]',
				'shadow-card',
				'relative',
				'h-full',
				'group',
			)}
		>
			{icon && <HoverIcon icon={icon} className="mb-8" />}

			<ArrowLink
				href={href}
				className={clsx(
					'font-display',
					'font-medium',
					description && 'mb-3',
					'after:absolute',
					'after:inset-0',
					'text-[21px]',
				)}
			>
				{title}
			</ArrowLink>

			{description && <div className={clsx('text-grey-15')}>{description}</div>}
		</div>
	);
};

export default LinkCard;
